// See IMAGE_ENCRYPTION_IMPL.md
(function () {
  const proto = HTMLCanvasElement.prototype;

  proto.toDataURL = function () {
    return 'data:image/png;base64,AAAA';
  };

  proto.toBlob = function (cb) {
    cb(new Blob());
  };

  const origGetContext = proto.getContext;
  proto.getContext = function (type, ...args) {
    const ctx = origGetContext.call(this, type, ...args);
    if (ctx && type === '2d') {
      ctx.getImageData = function () {
        return new ImageData(this.canvas.width, this.canvas.height);
      };
    }
    return ctx;
  };
}());
